import React, { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import dateString from 'lib/date-string'
import classNames from 'classnames'

import { toggleModal } from '../../store/ui/actions'
import { setMode } from '../../store/login-modal/actions'

import styles from './styles/TopBanner.css'
import { normalizeLicenseName } from '../../lib/organization-license-name'
import Header from '../typography/Header'
import headerLvl from 'components/typography/styles/Header.css'

const useOrgLogo = slug => {
  const [organizationLogo, setOrganizationLogo] = useState(null)

  useEffect(() => {
    if (!slug) {
      return
    }
    const imageUrl = `${CONFIG.assetsBaseURL}/images/organization-license-logos/${slug}.png`
    const image = new Image() // eslint-disable-line
    image.src = imageUrl
    image.onerror = () => setOrganizationLogo(null)
    image.onload = () => setOrganizationLogo(imageUrl)
  }, [slug])

  return organizationLogo
}

const licenseMessage = license => {
  const institutionName = normalizeLicenseName(license?.name)
  if (license?.status === 'TRIALING' || license?.status === 'TRIAL_READY') {
    if (license?.trialEndDate) {
      return `${institutionName} is trialing Scite until ${dateString(license?.trialEndDate)}.`
    } else {
      return `${institutionName} is trialing Scite.`
    }
  }
  return `${institutionName} subscribes to an organization-wide license of Scite.`
}

export const TopBanner = () => {
  const license = useSelector(({ ui }) => ui.organizationLicense)
  const dispatch = useDispatch()
  const user = useSelector(({ ui }) => ui.user)
  const fetchingUser = useSelector(({ ui }) => ui.fetchingUser)
  const organizationLogo = useOrgLogo(license?.slug)
  const [open, setOpen] = useState(false)
  const bhamTrial =
    license?.hasLicense &&
    license?.name === 'University of Birmingham' &&
    (license?.status === 'TRIALING' || license?.status === 'TRIAL_READY')

  useEffect(() => {
    setOpen(bhamTrial || (license?.licenseChecked && license?.hasLicense && !fetchingUser && !user?.email))
  }, [fetchingUser, license?.hasLicense, user?.email, bhamTrial])

  if (!open) return null

  const showLogin = () => {
    dispatch(toggleModal('login'))
    dispatch(setMode('login'))
  }

  const showRegister = () => {
    dispatch(toggleModal('login'))
    dispatch(setMode('register'))
  }

  return (
    <div className={styles.topBar}>
      <div
        className={classNames({
          [styles.topBarContent]: true,
          [styles.hasImage]: !!organizationLogo
        })}
      >
        {organizationLogo && (
          <div className={styles.image}>
            <img src={organizationLogo} alt='Organization Logo' />
          </div>
        )}
        <div className={styles.greeting}>
          <Header level={2} className={headerLvl.h5}>
            Welcome!
          </Header>
          {bhamTrial ? (
            <p>
              University of Birmingham is trialling Scite until July 6, 2025. We would value your user experience
              feedback via{' '}
              <a href='https://forms.office.com/e/cx8x9JVLVV' target='_blank' rel='noopener noreferrer'>
                this form
              </a>
            </p>
          ) : (
            <p>{licenseMessage(license)}</p>
          )}
        </div>
        {!user?.email && (
          <div className={styles.note}>
            You are not required to{' '}
            <a href='#' onClick={showRegister}>
              create an account
            </a>{' '}
            or{' '}
            <a href='#' onClick={showLogin}>
              log in
            </a>{' '}
            to search Scite. However, an account is needed to access many Scite features (e.g. notifications, Assistant
            history, and dashboards).
          </div>
        )}
      </div>
    </div>
  )
}
